<template>
  <div class="main-container">
    <pop-up-message
      v-if="showConfirmDelete"
      :message="'Are you sure you want to reset FNF ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Reset FNF'"

    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button
            class="btn-popup-secondary"
            type="button"
            @click="cancelEvent()"
          >Cancel</button>
          <button class="btn-popup" type="button" @click="confirmReset()">Reset</button>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
        v-if="showSuccessMsg"
        :message="Success"
        btnText="Back"
        @back="goBack()"
    ></pop-up-message>
    <breadcrumb
      main_step_name="Organisation"
      sub_step_name="Utilities"
      step_name="Full & Final Settlement"
      @goToMainStep="routeToMainStep"
      @goToSubStep="routeToSubStep"
    ></breadcrumb>
    <div class="empdetails">
      <div class="image">
        <img class="userImage" v-if="this.query.imgSrc == null" src="@/assets/user.svg" />
        <img class="userImage" v-else :src="this.query.imgSrc" />
        <br />
        <span class="input-label">{{this.query.code}}</span>
        <span class="input-label">
          <b>{{this.query.name}}</b>
        </span>
      </div>
      <div class="verticalLine"></div>
      <div class="personaldetail">
        <span class="input-label">{{this.query.designation}}</span>
        <span class="input-label">{{this.query.department}}</span>
        <br />
        <br />
        <span class="input-label">FnF Status</span>
        <span class="input-label">{{this.query.fnf_status}}</span>
      </div>
      <div class="contactdetail">
        <span>
          <img src="@/assets/phone-call.svg" />&nbsp;
          <span class="input-label">{{this.query.phone}}</span>
        </span>
        <span>
          <img src="@/assets/mail.svg" />&nbsp;
          <span class="input-label">{{this.query.email}}</span>
        </span>
        <span>
          <img src="@/assets/placeholder.svg" />&nbsp;
          <span class="input-label">{{this.query.location}}</span>
        </span>
        <br />
        <br />
        <span class="input-label">Reports to</span>
        <span class="input-label"><b>{{this.reportingManager}}</b></span>
      </div>
      <div class="amount">
        <p>Total Amount to be paid</p>
        <span>
          <b>₹{{Math.round(this.query.totalAmtPaid)}}</b>
        </span>
      </div>
    </div>
    <div v-show="!previewScreen" @selectedComponent="getSelectedComponents(val)">
      <tl-accordion headerName="Exit Details" :active="true">
        <template v-slot:accordionBody>
          <toast-message
          :message="errmsg"
          type="error"
          :isToastEnable="toast"
          @close="(val) => toast = val"
          />
          <div class="filters">
            <tl-select
              label="Reason For Exit"
              :options="reason"
              :value="formData.reason_for_exit"
              @change="(val)=>formData.reason_for_exit=val"
              :disable="exitdisable"
              v-model="formData.reason_for_exit"
            />
            <div>
              <div class="input-label">Resignation Date</div>
              <date-picker
                :formatDate="'yyyy-MM-dd'"
                @datevalue="updateDateValues"
                :value="formData.initiation_date"
                name="resignationDate"
                :disable="exitdisable"
                v-model="formData.initiation_date"
              />
            </div>
            <div>
              <div class="input-label">Last Working Day</div>
              <date-picker
                :formatDate="'yyyy-MM-dd'"
                @datevalue="(val)=>formData.last_working_date=val"
                :value="formData.last_working_date"
                name="lastwrkingDate"
                :disable="exitdisable || formData.initiation_date==''"
                :dates-disabled="{to: resignation_date}"
                v-model="formData.last_working_date"
              />
            </div>
          </div>
          <txt
            label="Remarks"
            type="textarea"
            rows="6"
            class="custom-width"
            :disable="exitdisable"
            v-model="formData.remarks"
          />
          <br />
          <div class="row-container">
            <btn type="secondary" v-show="!exitdisable" text="Cancel" @click="exitdisable=!exitdisable" />
            <btn :type="exitdisable ? 'secondary': 'primary'" :text="exitdisable?'Edit': 'Save'" @click="saveExitDetail" />
            <btn class="resetFnf" :type="exitdisable ? 'primary': 'secondary'" text="Reset FNF" @click="showPopup" />
          </div>
          <br />
        </template>
      </tl-accordion>
      <tl-accordion headerName="LOP/RLOP Details">
        <template v-slot:accordionBody>
          <div class="header header2">
            <span class="text">LOP</span>
          </div>
          <div class="lop">
            <!-- <div>
              <div class="input-label">Select Date/s</div>
              <date-picker
                @datevalue="(val)=>lop.dates=val"
                :value="lop.dates"
                name="resignationDate"
                :disable="lopdisable"
                v-model="formData.lop_dates"
              />
            </div> -->
            <txt label="No. of days" v-float-only :disable="lopdisable" v-model="formData.lop_days" class="lopdays" />
            <txt
              label="Amount"
              :disable="true"
              v-model="formData.lop_amount"
              class="lopdays"
            />
            <div class="calculate">
              <button class="export-button" @click="calculateLopDays()">Calculate</button>
            </div>
          </div>
          <div class="header header2">
            <span class="text">RLOP</span>
          </div>
          <div class="lop">
            <!-- <div>
              <div class="input-label">Select Date/s</div>
              <date-picker
                @datevalue="(val)=>rlop.dates=val"
                :value="rlop.dates"
                name="resignationDate"
                :disable="lopdisable"
                v-model="formData.rlop_dates"
              />
            </div> -->
            <txt label="No. of days" v-float-only :disable="lopdisable" v-model="formData.rlop_days" class="lopdays" />
            <txt
              label="Amount"
              :disable="true"
              v-model="formData.rlop_amount"
              class="lopdays"
            />
            <div class="calculate">
              <button class="export-button" @click="calculateRlopDays()">Calculate</button>
            </div>
          </div>
          <br />
          <div class="row-container">
            <btn type="secondary" v-show="!lopdisable" text="Cancel" @click="lopdisable=!lopdisable" />
            <btn :type="lopdisable ? 'secondary': 'primary'" :text="lopdisable?'Edit': 'Save'" @click="saveLopDetail" />
          </div>
          <br />
        </template>
      </tl-accordion>
      <tl-accordion headerName="Encashable Leaves">
        <template v-slot:accordionBody>
          <div class="lop">
            <txt
              label="No.of Utilised Leaves"
              :disable="leavedisable"
              v-float-only
              v-model="formData.utilised_leave"
              class="lopdays"
            />
            <txt
              label="No.of Unutilised Leaves"
              :disable="leavedisable"
              v-float-only
              v-model="formData.unutilised_leave"
              class="lopdays"
            />
            <txt
              label="Amount"
              :disable="(leaveEncashmentDisable || leavedisable)"
              v-model="formData.encashable_leave_value"
              class="lopdays"
            />
            <div class="calculate">
              <button class="export-button" @click="calculateDays()">Calculate</button>
            </div>
            <!-- <txt
              label="Amount"
              :disable="leavedisable"
              v-model="leavebalance.casual"
              class="lopdays"
            /> -->
          </div>
          <br />
          <div class="row-container">
            <btn type="secondary" v-show="!leavedisable" text="Cancel" @click="leavedisable=!leavedisable" />
            <btn :type="leavedisable ? 'secondary': 'primary'" :text="leavedisable?'Edit': 'Save'" @click="saveLeaveDetail" />
          </div>
          <br />
        </template>
      </tl-accordion>
      <tl-accordion headerName="Notice Pay Earning/Notice Pay Recovery">
        <template v-slot:accordionBody>
          <div class="radio">
            <tl-radio
              name="notice"
              label="Notice Pay Earning"
              id="notice1"
              value="pay"
              v-model="notice"
              :checked="notice"
            />
            <div class="notice2">
              <tl-radio
                name="notice"
                label="Notice Pay Recovery"
                id="notice2"
                value="recovery"
                v-model="notice"
              />
            </div>
          </div>
          <br />
          <div v-if="notice==='pay'">
            <div class="row">
              <div class="lop">
                <txt
                  label="No. of Days"
                  v-float-only
                  :disable="noticedisable"
                  v-model="formData.notice_pay_days"
                  class="noticedays"
                />
                <txt
                  label="Amount"
                  :disable="noticedisable"
                  v-model="formData.notice_pay_value"
                  class="lopdays"
                />
                <div class="calculate">
                   <button class="export-button" @click="calculateNoticePay()">Calculate</button>
                </div>
              </div>
            </div>
            <div class="lop">
              <txt
                v-if="paySelect!=''"
                :label="paySelect=='Notice Period'? 'Number of Days': 'Notice Period Amount'"
                v-model="noticePayRecovery.pay"
              />
            </div>
          </div>
          <div v-if="notice==='recovery'">
            <div class="row">
              <div class="lop">
                <txt
                  label="No. of Days"
                  :disable="noticedisable"
                  v-float-only
                  v-model="formData.notice_recovery_days"
                  class="lopdays"
                />
                <txt
                  label="Amount"
                  :disable="noticedisable"
                  v-model="formData.notice_recovery_value"
                  class="lopdays"
                />
                <div class="calculate">
                   <button class="export-button" @click="calculateNoticeRecovery()">Calculate</button>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="row-container">
            <btn type="secondary" v-show="!noticedisable" text="Cancel" @click="noticedisable=!noticedisable" />
            <btn :type="noticedisable ? 'secondary': 'primary'" :text="noticedisable?'Edit': 'Save'" @click="saveNoticeDetail" />
          </div>
        </template>
      </tl-accordion>
      <tl-accordion headerName="Gratuity Pay">
        <template v-slot:accordionBody>
          <div class="gratuity">
            <txt
              class="custom-width2"
              label="Gratuity Period"
              v-model="formData.gratuity_period"
              :disable="true"
            />
            <div class="custom-div">years</div>
            <div>
             
              <!-- <txt
                class="custom-width3"
                v-model="gratuityPayPeriod.month"
                :disable="gratuitydisablemonth"
              /> -->
              <txt
                class="custom-width3"
                v-model="formData.gratuity_month"
                :disable="true"
              /> 
              <div class="custom-div">month</div>
            </div>
            <txt
              label="Gratuity Amount"
              v-model="formData.gratuity_amount"
              :disable="gratuitydisableamount"
            />
             <!-- <div class="calculate">
              <button class="export-button" @click="calculateGratuityAmont()">Calculate</button>
            </div> -->
          </div>  
          <br />
          <br />
          <div class="row-container" v-if="false">
            <btn type="secondary" v-show="!noticedisable" text="Cancel" @click="noticedisable=!noticedisable" />
            <btn :type="noticedisable ? 'secondary': 'primary'" :text="noticedisable?'Edit': 'Save'" @click="saveNoticeDetail" />
          </div>
          <btn
            v-if="gratuitydisableperiod||gratuitydisableamount||gratuitydisablemonth"
            type="secondary"
            :text="gratuitydisableperiod?'Edit': 'Save'"
            @click="editGratuiryAmount('gratuityPayPeriod')"
          />
          <btn
            v-else
            type="secondary"
            :text="gratuitydisableperiod?'Edit': 'Save'"
            @click="editGratuiryAmount('gratuityPayPeriod')"
          /> 
          <br />
        </template>
      </tl-accordion>
      <tl-accordion headerName="Variable Salary Components">
        <template v-slot:accordionBody>
          <!-- <span class="variableClass" @click="fetchSalaryComponents">Variable Salary Components</span> -->
          <data-table :columns="tableColumnsVariable" :tableData="tableDataVariable" :showinrow="false">
            <template v-slot:rowcontent="slotprops">
              <txt
                v-if="variableDisable && slotprops.value.column.key == 'adjustment_amount'"
                v-model="slotprops.value.record[slotprops.value.column.key]"
                @blur="(val)=>saveValuesVariables(slotprops.value.record[slotprops.value.column.key],slotprops.value.record,'adjustment_amount')"
              />
            </template>
          </data-table>
          <br />
          <div class="row-container">
            <btn type="secondary" v-show="variableDisable" text="Cancel" @click="variableDisable=!variableDisable" />
            <btn :type="!variableDisable ? 'secondary': 'primary'" :text="!variableDisable?'Edit': 'Save'" @click="saveVariableDetail" />
          </div>
          <br />
        </template>
      </tl-accordion>
      <!-- <tl-accordion headerName="IT Declaration">
        <template v-slot:accordionBody>
          <data-table :columns="tableColumns" :tableData="tableData" :showinrow="false">
            <template v-slot:rowcontent="slotprops">
              <p
                v-if="!editIT || slotprops.value.column.key == 'particulars' || slotprops.value.column.key == 'proof'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <txt
                v-if="editIT && slotprops.value.column.key == 'amount'"
                v-model="slotprops.value.record[slotprops.value.column.key]"
                @blur="(val)=>saveValues(slotprops.value.record[slotprops.value.column.key],slotprops.value.record,'amount')"
              />
              <txt
                v-if="editIT && slotprops.value.column.key == 'validated'"
                v-model="slotprops.value.record[slotprops.value.column.key]"
                @blur="(val)=>saveValues(slotprops.value.record[slotprops.value.column.key],slotprops.value.record,'validated')"
              />
            </template>
          </data-table>
          <br />
          <div class="row-container">
            <btn type="secondary" v-show="editIT" text="Cancel" @click="editIT=!editIT" />
            <btn :type="!editIT ? 'secondary': 'primary'" :text="!editIT?'Edit': 'Save'" @click="saveITDetail" />
          </div>
          <br />
        </template>
      </tl-accordion> -->
      <!-- <tl-accordion headerName="FBP Components">
        <template v-slot:accordionBody>
          <div class="lop" v-if="editfbp">
            <div class="amount">
              <p>Eligiblity</p>
              <span>
                <b>₹{{ fbpComponents.eligible }}</b>
              </span>
            </div>
            <div class="amount">
              <p>Claimed</p>
              <span>
                <b>₹{{ fbpComponents.claimed }}</b>
              </span>
            </div>
            <div class="amount">
              <p>Approved</p>
              <span>
                <b>₹{{ fbpComponents.approved }}</b>
              </span>
            </div>
          </div> -->
          <!-- <br> -->
          <!-- <div class="editFbpClass" v-else>
            <txt class="editFbpClass" label="Eligibility" v-model="fbpComponents.eligible" />
            <txt class="editFbpClass" label="Claimed" v-model="fbpComponents.claimed" />
            <txt class="editFbpClass" label="Approved" v-model="fbpComponents.approved" />
            <br />
          </div>
          <br />
          <div class="row-container">
            <btn type="secondary" v-show="!editfbp" text="Cancel" @click="editfbp=!editfbp" />
            <btn :type="editfbp ? 'secondary': 'primary'" :text="editfbp?'Edit': 'Save'" @click="saveFbpDetail" />
          </div>
          <br />
        </template>
      </tl-accordion> -->
      <!-- <tl-accordion headerName="Pending Loan Amount">
        <template v-slot:accordionBody>
          <div class="lop">
            <txt
              label="Loan Amount"
              :disable="loandisable"
              v-model="loanAmount.amount"
              class="lopdays"
            />
          </div>
          <br />
          <div class="row-container">
            <btn type="secondary" v-show="!loandisable" text="Cancel" @click="loandisable=!loandisable" />
            <btn :type="loandisable ? 'secondary': 'primary'" :text="loandisable?'Edit': 'Save'" @click="saveLoanDetail" />
          </div>
        </template>
      </tl-accordion> -->
    </div>
    <div v-show="previewScreen">
      <br />
      <br />
      <br />
      <div class="summary-cards">
        <div class="rect">
          <span>Exit Details</span>
          <div class="line" />
          <div class="exit-details">
            <span>Reason For Exit</span>
            <span>
              <b>{{ formData.reason_for_exit }}</b>
            </span>
          </div>
          <div class="exit-details">
            <span>Last Working Day</span>
            <span>
              <b>{{ formData.last_working_date }}</b>
            </span>
          </div>
        </div>
        <div class="rect">
          <span>LOP/RLOP</span>
          <div class="line" />
          <div class="exit-details">
            <span>No. of LOP days</span>
            <span>
              <b>{{ formData.lop_days }}</b>
            </span>
          </div>
          <div class="exit-details">
            <span>No. of RLOP days</span>
            <span>
              <b>{{ formData.rlop_days }}</b>
            </span>
          </div>
          <div class="exit-details">
            <span>LOP Amount</span>
            <span>
              <b>{{ formData.lop_amount }}</b>
            </span>
          </div>
          <div class="exit-details">
            <span>RLOP Amount</span>
            <span>
              <b>{{ formData.rlop_amount }}</b>
            </span>
          </div>
        </div>
        <div class="rect">
          <span>Encashable Leaves</span>
          <div class="line" />
          <div class="exit-details">
            <span>No. of Utilised Leaves</span>
            <span>
              <b>{{ formData.utilised_leave }}</b>
            </span>
          </div>
          <div class="exit-details">
            <span>No. of Unutilised Leaves</span>
            <span>
              <b>{{ formData.unutilised_leave }}</b>
            </span>
          </div>
          <div class="exit-details">
            <span>Amount</span>
            <span>
              <b>₹ {{ formData.encashable_leave_value }}</b>
            </span>
          </div>
        </div>
        <div class="rect">
          <span>Notice Pay Earning</span>
          <div class="line" />
          <div class="exit-details">
            <span>No. of days</span>
            <span>
              <b>{{formData.notice_pay_days}}</b>
            </span>
          </div>
          <div class="exit-details">
            <span>Amount</span>
            <span>
              <b>{{formData.notice_pay_value}}</b>
            </span>
          </div>
        </div> 
      </div>
      <div class="summary-cards">
        <div class="rect">
          <span>Notice Pay Recovery</span>
          <div class="line" />
          <div class="exit-details">
            <span>No. of days</span>
            <span>
              <b>{{formData.notice_recovery_days}}</b>
            </span>
          </div>
          <div class="exit-details">
            <span>Amount</span>
            <span>
              <b>{{formData.notice_recovery_value}}</b>
            </span>
          </div>
        </div>
        <div class="rect">
          <span>Gratuity Pay</span>
          <div class="line" />
          <div class="exit-details" v-if="gratuity=='period'">
            <span>Gratuity Period</span>
            <span>
              <b>{{ formData.gratuity_period }} Years {{formData.gratuity_month}} Months</b>
            </span>
          </div>
          <div class="exit-details" v-if="gratuity=='amount'">
            <span>Gratuity Period</span>
            <span>
              <b>{{gratuityPayPeriod.years}}</b>
            </span>
          </div>
          <div class="exit-details">
            <span>Amount</span>
            <span>
              <b>{{ formData.gratuity_amount }}</b>
            </span>
          </div>
        </div>
        <div class="var-rect">
          <span>Variable Salary Components</span>
          <div class="line" />
          <div class="exit-details"  v-for="(item, index) in getSalaryComponents" :key="index">
            <span>{{item.component}}</span>
            <span>
              <b>₹{{item.adjustment_amount}}</b>
            </span>
          </div>
        </div>
        <!-- <div class="var-rect">
          <span>IT Declaration</span>
          <div class="line" />
          <div class="exit-details"  v-for="(item, index) in itDeclaration" :key="index">
            <span>{{item.particulars}}</span>
            <span>
              <b>₹{{item.validated == undefined ? 0 : item.validated }}</b>
            </span>
          </div>
        </div> -->
        <!-- <div class="rect">
          <span>FBP Components</span>
          <div class="line" />
          <div class="exit-details">
            <span>Approved (8)</span>
            <span>
              <b>₹ 14,000</b>
            </span>
          </div>
          <div class="exit-details">
            <span>Unclaimed</span>
            <span>
              <b>₹ 7,000</b>
            </span>
          </div>
        </div> -->
      </div>
      <!-- <div class="summary-cards"> -->
      <!-- <div class="custom-rect">
        <span>Pending Loan Amount</span>
        <div class="line" />
        <div class="exit-details">
          <span>Car Loan</span>
          <span>
            <b>₹ 50,000 {{loanAmount.amount}}</b>
          </span>
        </div>
      </div> -->
      <!-- </div> -->
    </div>

    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <!-- <btn text="Cancel" @click="$router.go(-1)" /> -->
          <btn v-if="previewScreen" text="Back" type="secondary" @click="back" />
          <btn :text="previewScreen? 'Proceed': 'Preview'" type="primary" @click="preview" />
        </btn-grp>
      </template>
    </bottom-action-container>

    <!-- <variable-components v-if="showSalaryComponents"/> -->
  </div>
  <!-- </div> -->
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import VariableComponents from "./variableComponents.vue";

export default {
  components: {
    VariableComponents
  },
  data() {
    return {
      showConfirmDelete: false,
      showSuccessMsg: false,
      popupType: "ConfirmDelete",
      query: {
        imgSrc:"",
        code:"",
        name:"",
        designation:"",
        department:"",
        phone:"",
        email:"",
        location:"",
        reports:"",
        fnf_status:"",
        totalAmtPaid:""
      },
      reason: ["Resigned"],
      previewScreen: false,
      exitdisable: true,
      lopdisable: true,
      leavedisable: true,
      noticedisable: true,
      toast: false,
      errmsg: "",
      resignation_date: '',
      gratuitydisableperiod: true,
      gratuitydisableamount: true,
      gratuitydisablemonth: true,
      salarydisable: true,
      editfbp: true,
      loandisable: true,
      notice: "pay",
      gratuity: "period",
      paySelect: "",
      editIT: false,
      fbpComponentId: "",
      fbpComponents: {
        eligible: 0,
        claimed: 0,
        approved: 0
      },
      exitDetails: {
        reason: "",
        resignationDate: "",
        lastwrkingDate: ""
      },
      lop: {
        days: "",
        dates: ""
      },
      rlop: {
        days: "",
        dates: ""
      },
      leavebalance: {
        NoofDays: "",
        Amount: ""
      },
      noticePayRecovery: {
        noofdays: "",
        amt: ""
      },
      gratuityPayPeriod: {
        years: "",
        amount: "",
        month: ""
      },
      // gratuityPayAmt:{

      // },
      // gratuityPayMonth:{
      //     month: ''
      // },
      salaryAdjustment: {},
      loanAmount: {
        amount: ""
      },
      tableColumns: [
        {
          label: "Particulars",
          key: "particulars"
        },
        {
          label: "Declared Amount ",
          key: "amount"
        },
        {
          label: "Proof",
          key: "proof"
        },
        {
          label: "Validated",
          key: "validated"
        }
      ],
      tableData: [],
      getSalaryComponents: [],
      itDeclaration:[],
      dataList: [
        {
          particulars: "Medical",
          billDate: "07 July 2019",
          claimAmount: "₹2000.00",
          bills: "attachment1.pdf",
          eligiblityAmount: "₹2000.00",
          approved: "2000",
          reject: "",
          onHold: "",
          remark: ""
        },
        {
          particulars: "",
          billDate: "07 July 2019",
          claimAmount: "₹2000.00",
          bills: "attachment2.pdf",
          eligiblityAmount: "₹2000.00",
          approved: "200dd0",
          reject: "",
          onHold: "",
          remark: ""
        }
      ],
      headerColumnList: [
        { label: "Particulars", key: "particulars" },
        { label: "Bill Date", key: "billDate" },
        { label: "Claim Amount", key: "claimAmount" },
        { label: "Bills", key: "bills" },
        { label: "Eligiblity Amount", key: "eligiblityAmount" },
        { label: "Approved", key: "approved", enable: false },
        { label: "Reject", key: "reject" },
        { label: "On Hold", key: "onHold" },
        { label: "Remark", key: "remark" }
      ],
      formData: {
        employee_id: null,
        le_id: null,
        fnf_status: null,
        leaveEncashmentDisable : true,
        reason_for_exit:null,
        initiation_date: "",
        last_working_date: "",
        last_ess_date : "",
        remarks: "",
        utilised_leave: 0,
        unutilised_leave: 0,
        //encashablle_leaves_value: true,
        encashable_leave_value: 0,
        lop_dates: [], //json array
        lop_days : 0,
        rlop_dates :  [], //json array
        rlop_days : 0,
        status : "", //['resigned', 'fired', 'retired']
        gratuity_period: 0,
        gratuity_amount: 0,
        gratuity_month: 0,
        variable_components: null, //json array
        it_declaration: null, //json array
        fbp: [],
        loan: [
           // {"type": "car loan","amount": 5000}
        ],
        notice_pay_value:0,
        notice_pay_days:0,
        notice_recovery_value: 0,
        notice_recovery_days: 0,
        processed_fnf_flag: "",
        lop_amount: 0,
        rlop_amount: 0,
     },
     monthsList: [
        { name: "January", value: "jan" },
        { name: "February", value: "feb" },
        { name: "March", value: "mar" },
        { name: "April", value: "apr" },
        { name: "May", value: "may" },
        { name: "June", value: "jun" },
        { name: "July", value: "jul" },
        { name: "August", value: "aug" },
        { name: "September", value: "sep" },
        { name: "October", value: "oct" },
        { name: "November", value: "nov" },
        { name: "December", value: "dec" }
      ],
      showSalaryComponents: false,
      amount: null,
      reportingManagerId: null,
      reportingManager: null,
      validated: null,
      itlist:[],
      salaryComponents: [],
      model: {},
      selectedComponents: [],
      variableList: [],
      variableDisable: false,
      tableColumnsVariable: [
        {
          label: "Component",
          key: "component"
        },
        {
          label: "Type",
          key: "type"
        },
        {
          label: "Adjustment Amount",
          key: "adjustment_amount"
        },
      ], 
      tableDataVariable: [],
      variableListNew: [],
      empData: []
    };
  },
  mounted() {
    this.fetchEmpFnfData();
    this.fetchAllComponents();
  },
  activated() {
    this.getSelectedEmpData();
    this.getSelectedComponents();
    this.fetchEmpFnfData();
    this.fetchAllComponents();
  },
  computed: {
    ...mapState({
      empFnfData: state => state.dashboard.organisation.processfnf.data,
      editMode: state => state.dashboard.organisation.processfnf.data,
      record: state => state.dashboard.organisation.processfnf.record
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    }
  },
  methods: {
    ...mapActions({
      act_fetchEmpData: 'dashboard/organisation/processfnf/fetchAll',
      act_create: 'dashboard/organisation/processfnf/create',
      act_update: 'dashboard/organisation/processfnf/update',
      act_changeEditMode: 'dashboard/organisation/processfnf/changeEditMode',
      act_fetch_manager: 'dashboard/organisation/processfnf/fetchReportingManager',
      act_fetch_fnf_days: 'dashboard/organisation/processfnf/fetchFnfDays',
      act_fetch_fnf_gratuity_pay: 'dashboard/organisation/processfnf/fetchFnfGratuityPay',
      act_fetchAll: "onboard/settings/salary_component/fetchAll",
      act_update_gratuity_amount: 'dashboard/organisation/processfnf/updateGratuityAmount',
      act_reset_fnf: 'dashboard/organisation/processfnf/resetFnf'
    }),
    updateDateValues(value, dateObj) {
      this.formData.initiation_date = value;
      this.resignation_date = dateObj;
    },
    async fetchEmpFnfData() {
      // this.tableDataVariable = [];
      try {
        this.formData.le_id = this.leId;
        //this.formData.employee_id = this.record.id;
        this.formData.employee_id = this.record.employee_id;
        this.formData.processed_fnf_flag = this.record.processed_fnf_flag;
        let year = this.record.last_working_date.substring(0, 4);
        let date = new Date(this.record.last_working_date);
        let month = date.toLocaleString('default', { month: 'long' });
        let res = await this.act_fetchEmpData({
          le_id: this.leId,
          emp_id: this.record.employee_id,
          financial_year: year,
          month: month.substring(0,3).toLowerCase()
        })
        this.empData.push(res)
        this.query.imgSrc = res.data.payload.empDetails.photo_url;
        this.query.code = res.data.payload.empDetails.code;
        let lastName = res.data.payload.empDetails.last_name == null ? "" : res.data.payload.empDetails.last_name;
        this.query.name = res.data.payload.empDetails.first_name+ " " +lastName;
        //this.query.designation = res.data.paylinitiation_dateoad.empDetails.;
        //this.query.department = res.data.payload.empDetails.;
        this.query.phone = res.data.payload.empDetails.mobile_number;
        this.query.email = res.data.payload.empDetails.email_id;
        this.query.fnf_status = res.data.payload.exitDetails.fnf_status;
        this.query.location = res.data.payload.location ? res.data.payload.location : "";
        //this.query.reports = res.data.payload.empDetails;
        this.query.totalAmtPaid = res.data.payload.totalAmtPaid;
        this.formData.remarks = res.data.payload.exitDetails.remarks;
        this.formData.reason_for_exit = res.data.payload.exitDetails.reason_for_exit;
        this.formData.status = res.data.payload.exitDetails.reason_for_exit;
        this.formData.initiation_date = res.data.payload.exitDetails.initiation_date;
        this.formData.last_working_date = res.data.payload.exitDetails.last_working_date;
        this.reportingManagerId = res.data.payload.empDetails.EmployeeOfficial.reporting_manager_id;
        if(this.reportingManagerId !== null){
        let employeeid = this.reportingManagerId;
        const response = await this.act_fetch_manager({
          employeeid
        });
        //console.log(response.data.payload, "222");
        this.reportingManager = response.data.payload.emp[0].first_name+ " " +(response.data.payload.emp[0].last_name ? response.data.payload.emp[0].last_name : "");
        }
        this.tableData = [];
        this.itlist = [];
        if(res.data.payload.exitDetails.it_declaration !== null && res.data.payload.exitDetails.it_declaration.length > 0) {
          res.data.payload.exitDetails.it_declaration.forEach((ele) =>{
            this.tableData.push(
              {
                particulars: ele.name,
                amount: ele.planned,
                proof: ele.actual,
                validated: ele.validated,
                id: ele.id
              });
          })
        } else {
          res.data.payload.itDeclarationList.payload.forEach((ele) =>{
            this.tableData.push(
              {
                particulars: ele.InvestmentComponentType.name,
                amount: ele.planned,
                proof: ele.actual,
                validated: ele.validated,
                id: ele.InvestmentComponentType.id
              });
          })
          //this.tableData = res.data.payload.exitDetails.it_declaration;
        }
        this.tableData.forEach(element => {
          let isPresent = this.itlist.some(x => x.name === element.particulars);
          if(!isPresent) {
            this.itlist.push({
              name: element.particulars,
              planned: element.amount,
              actual: element.proof,
              validated: element.validated,
              id: element.id
            });
          }
        })
        
        this.formData.gratuity_period = res.data.payload.gratuity.gratuity_period ? res.data.payload.gratuity.gratuity_period : res.data.payload.gratuity.years;
        this.formData.gratuity_amount = (res.data.payload.gratuity.gratuity_amount) ? res.data.payload.gratuity.gratuity_amount : 0;
        this.formData.gratuity_month = res.data.payload.gratuity.gratuity_month ? res.data.payload.gratuity.gratuity_month : res.data.payload.gratuity.month;
        //this.gratuityPayPeriod.month =  res.data.payload.gratuity.month;
      
      this.formData.utilised_leave = res.data.payload.exitDetails.utilised_leave;
      this.formData.unutilised_leave = res.data.payload.exitDetails.unutilised_leave;
      this.formData.encashable_leave_value = res.data.payload.exitDetails.encashable_leave_value;
      this.formData.notice_pay_days = res.data.payload.exitDetails.notice_pay_days;
      this.formData.notice_pay_value = res.data.payload.exitDetails.notice_pay_value;
      this.formData.notice_recovery_days = res.data.payload.exitDetails.notice_recovery_days;
      this.formData.notice_recovery_value = res.data.payload.exitDetails.notice_recovery_value;

      //this.salaryComponents = res.data.payload.salaryComponentList;
      this.tableDataVariable = [];
      this.variableListNew = [];
      if(res && res.data && res.data.payload && res.data.payload.salaryComponentList && res.data.payload.salaryComponentList.length > 0 && (res.data.payload.exitDetails.variable_components === null || res.data.payload.exitDetails.variable_components.length == 0)) {
        res.data.payload.salaryComponentList.forEach((ele) =>{
            if(!ele.name == "" && ele.salary_component_type == "VARIABLE" && ele.name != "Notice period recovery" && ele.name != "Notice period Pay") {
              this.tableDataVariable.push(
              {
                component: ele.name,
                type: ele.transaction_type,
                adjustment_amount: ele.calculation[0].formula,
                component_type: ele.salary_component_type
              });
            }
          })
      } else {
          if(res.data.payload.exitDetails.variable_components !== null && res.data.payload.exitDetails.variable_components.length > 0) {
            res.data.payload.exitDetails.variable_components.forEach((ele) =>{
              if(ele.component !== "" && ele.component != "Notice period recovery" && ele.component != "Notice period Pay") { 
                this.tableDataVariable.push(
                {
                  component: ele.component,
                  type: ele.type,
                  adjustment_amount: ele.adjustment_amount
                });
              }
            })
          } 
        }
        this.tableDataVariable.forEach(element => {
          let isPresent = this.variableListNew.some(x => x.component === element.component);
          if(!isPresent) {
            this.variableListNew.push({
              component: element.component,
              type: element.type,
              adjustment_amount: element.adjustment_amount
            });
          }
      })
        
      // res.data.payload.salaryComponentList.forEach((ele) =>{
      //   this.tableDataVariable.push(
      //   {
      //     component: ele.name,
      //     type: ele.transaction_type,
      //     adjustment_amount: 0
      //   }
      //   );
      // })
      
      if(res && res.data && res.data.payload &&  res.data.payload.exitDetails && res.data.payload.exitDetails.lop_days && res.data.payload.exitDetails.lop_days > 0) {
        this.formData.lop_days = res.data.payload.exitDetails.lop_days;
        this.formData.lop_amount = res.data.payload.exitDetails.lop_amount;
      } else {
        const lopValues = res.data.payload.lopDetails.length ? (res.data.payload.lopDetails[0].no_of_lop_days ? Object.values(res.data.payload.lopDetails[0].no_of_lop_days) : null) : null;
        if(lopValues){
          this.formData.lop_days = lopValues.reduce((acc, value) => {
            return acc + value;
          }, 0);
        }
      }
      
      if(res && res.data && res.data.payload &&  res.data.payload.exitDetails && res.data.payload.exitDetails.rlop_days && res.data.payload.exitDetails.rlop_days > 0) {
        this.formData.rlop_days = res.data.payload.exitDetails.rlop_days;
        this.formData.rlop_date = res.data.payload.salaryRegisterData.rlop.total;
        this.formData.rlop_amount = res.data.payload.exitDetails.rlop_amount;
      } else {
        const rlopValues = res.data.payload.lopDetails.length ? (res.data.payload.lopDetails[0].no_of_rlop_days ? Object.values(res.data.payload.lopDetails[0].no_of_rlop_days) : null) : null;
         if(rlopValues){
          this.formData.no_of_rlop_days = rlopValues.reduce((acc, value) => {
            return acc + value;
          }, 0);
         }
      }
      
      this.formData.lop_dates = res.data.payload.exitDetails.lop_dates;
      this.formData.rlop_dates = res.data.payload.exitDetails.rlop_dates;
      
      if(res && res.data && res.data.payload && res.data.payload.lopDetails[0] && res.data.payload.lopDetails[0].lop_days) {
        this.formData.lop_dates = res.data.payload.lopDetails[0].lop_days[res.data.payload.lopDetails[0].lop_days.length-1];
      } else {
        this.formData.lop_dates = null;
      }
      if(res && res.data && res.data.payload && res.data.payload.lopDetails[0] && res.data.payload.lopDetails[0].rlop_date) {
        this.formData.rlop_dates = res.data.payload.lopDetails[0].rlop_date[res.data.payload.lopDetails[0].rlop_date.length-1];
      } else {
        this.formData.rlop_dates = null;
      }
      
      } catch (error) {
        //console.log('error', error);
      }
    },
    async saveEmpFnfData() {
      try {
        this.$root._data.isSaving = true;
         this.formData.fnf_status="processed"
        let res = await this.act_create({
        	data: this.formData
        });
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
        this.$root._data.isSaving = false;
        //console.log('error', error);
      }
    },
    async updateEmpFnfData(dataEdit) {
      try {
        this.$root._data.isSaving = true;
        let res = await this.act_update({
      	  data: this.formData
        })
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
        this.$root._data.isSaving = false;
        //console.log('error', error);
      }
    },
    async updateGratuityAmount(data) {
      try {
        this.$root._data.isSaving = true;
        let res = await this.act_update_gratuity_amount({
      	  data: data
        })
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
        this.$root._data.isSaving = false;
        //console.log('error', error);
      }
    },
    getSelectedEmpData(empData) {
      //console.log("employee data selected", empData);
    },
    getSelectedComponents(val) {
        //console.log('values of se;ected component', val)
    },
    edit(val) {
      if (val == "edit") this.exitdisable = !this.exitdisable;
      if (val == "lop") this.lopdisable = !this.lopdisable;
      if (val == "leavebalance") this.leavedisable = !this.leavedisable;
      if (val == "noticePayRecovery") this.noticedisable = !this.noticedisable;
      if (val == "gratuityPayPeriod") {
        this.gratuitydisableperiod = !this.gratuitydisableperiod;
        this.gratuitydisableamount = !this.gratuitydisableamount;
        this.gratuitydisablemonth = !this.gratuitydisablemonth;
        if (this.gratuitydisableperiod || this.gratuitydisableamount || this.gratuitydisablemonth) {
          this.formData.status = this.formData.reason_for_exit;
          this.formData.id = this.record.fnfID;
          this.formData.it_declaration = [...this.itlist];
          this.formData.variable_components = [...this.variableListNew];
          this.formData.fnf_status = "pending";
          this.formData.processed_fnf_flag = this.record.processed_fnf_flag;
          this.updateEmpFnfData(this.formData);
        }
      }
      //   if(val == 'gratuityPayAmt')
      //   this.gratuitydisableamount = !this.gratuitydisableamount
      //   if(val == 'gratuityPayMonth')
      //   this.gratuitydisablemonth = !this.gratuitydisablemonth
      if (val == "salary") this.salarydisable = !this.salarydisable;
      if (val == "loan") this.loandisable = !this.loandisable;
    },
    editGratuiryAmount(val) {
      if (val == "gratuityPayPeriod") {
        let data = {}
        this.gratuitydisableperiod = !this.gratuitydisableperiod;
        this.gratuitydisableamount = !this.gratuitydisableamount;
        this.gratuitydisablemonth = !this.gratuitydisablemonth;
        if (this.gratuitydisableperiod || this.gratuitydisableamount || this.gratuitydisablemonth) {
          data.employee_id = this.formData.employee_id;
          data.le_id = this.formData.le_id;
          data.gratuity_amount = this.formData.gratuity_amount;
          data.initiation_date = this.formData.initiation_date;
          data.last_working_date = this.formData.last_working_date;
          data.fnf_status = "pending";
          this.updateGratuityAmount(data);
        }
      }
    },

    showPopup(){
      this.showConfirmDelete = true;
    },

    cancelEvent(){
      this.showConfirmDelete = false;
    },

    async confirmReset(){
      try {
        let loginId = localStorage.getItem('loginId')
        let obj ={
          emp_id: this.record.employee_id,
          le_id: this.leId,
          login_email: loginId
        }
        let res = await this.act_reset_fnf(obj);
        if(res.data.status){
          this.showSuccessMsg = true;
          this.showConfirmDelete = false;
        }
      } catch (error) {
        this.showConfirmDelete = false;
        this.toast = true;
        this.errmsg = error;
      }
    },

    goBack(){
      this.showSuccessMsg = false;
      this.refresh();
    },

    refresh(){
      this.fetchEmpFnfData();
      this.fetchAllComponents();
    },

    saveExitDetail() {
      this.exitdisable = !this.exitdisable;
      if (this.exitdisable) {
          this.formData.status = this.formData.reason_for_exit;
          this.formData.id = this.record.fnfID;
          this.formData.it_declaration = [...this.itlist];
          this.formData.variable_components = [...this.variableListNew];
          this.formData.fnf_status = "pending";
          this.formData.processed_fnf_flag = this.record.processed_fnf_flag;
          this.updateEmpFnfData(this.formData);
      }
    },
    saveLopDetail() {
      this.lopdisable = !this.lopdisable;
      if (this.lopdisable) {
        this.formData.status = this.formData.reason_for_exit;
        this.formData.id = this.record.fnfID;
        this.formData.it_declaration = [...this.itlist];
        this.formData.variable_components = [...this.variableListNew];
        this.formData.fnf_status = "pending";
        this.formData.processed_fnf_flag = this.record.processed_fnf_flag;
        this.updateEmpFnfData(this.formData);
        this.fetchEmpFnfData()
      }
    },

    /** Function to fetch the Salary components list data from server */
    async fetchAllComponents() {
      try {
        let res = await this.act_fetchAll(this.leId);
        if(res.data.payload && res.data.payload.data){
          res.data.payload.data.map(el => {
            if(el.abbreviation === "LE"){
              this.leaveEncashmentDisable = el.calculation_type == "FLAT" ? false : true;
            }
          })
        }
        if (res.message != null) {
          throw Error(res.message);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async calculateDays() {
       try {
        this.formData.le_id = this.leId;
        //this.formData.employee_id = this.record.id;
        this.formData.employee_id = this.record.employee_id;
        this.formData.processed_fnf_flag = this.record.processed_fnf_flag;
        let year = this.record.last_working_date.substring(0, 4);
        let date = new Date(this.record.last_working_date);
        let month = date.toLocaleString('default', { month: 'long' });
        let res = await this.act_fetch_fnf_days({
          le_id: this.leId,
          emp_id: this.record.employee_id,
          financial_year: year,
          month: month.substring(0,3).toLowerCase(),
          utilised_leave: this.formData.utilised_leave,
          unutilised_leave: this.formData.unutilised_leave,
        })                                                                                                                                                                                        
        this.formData.encashable_leave_value = Math.round(res.data.payload);
       } catch (error) {
        //console.log(error);
       }
    },
     
     async calculateGratuityAmont(){
       try{
        this.formData.le_id = this.leId;
        this.formData.employee_id = this.record.employee_id;
        let year = this.record.last_working_date.substring(0, 4);
        let date = new Date(this.record.last_working_date);
        let month = date.toLocaleString('default', { month: 'long' });
        let res = await this.act_fetch_fnf_gratuity_pay({
          le_id: this.leId,
          emp_id: this.record.employee_id,
          financial_year: year,
          month: month.substring(0,3).toLowerCase(),
          gratuityYears: this.formData.gratuity_period,
          gratuityMonths: this.formData.gratuity_month
        })
         this.formData.gratuity_amount = Math.round(res.data.payload.amount)
       } catch(error){
         //console.log(error);
       }
     },

    async calculateNoticePay() {
       try {
        this.formData.le_id = this.leId;
        //this.formData.employee_id = this.record.id;
        this.formData.employee_id = this.record.employee_id;
        this.formData.processed_fnf_flag = this.record.processed_fnf_flag;
        let year = this.record.last_working_date.substring(0, 4);
        let date = new Date(this.record.last_working_date);
        let month = date.toLocaleString('default', { month: 'long' });
        let res = await this.act_fetch_fnf_days({
          le_id: this.leId,
          emp_id: this.record.employee_id,
          financial_year: year,
          month: month.substring(0,3).toLowerCase(),
          notice_pay_days: this.formData.notice_pay_days
        })
        //console.log(res, "dayss");
        this.formData.notice_pay_value = Math.round(res.data.payload);
       } catch (error) {
        //console.log(error);
       }
    },
    async calculateNoticeRecovery() {
       try {
        this.formData.le_id = this.leId;
        //this.formData.employee_id = this.record.id;
        this.formData.employee_id = this.record.employee_id;
        this.formData.processed_fnf_flag = this.record.processed_fnf_flag;
        let year = this.record.last_working_date.substring(0, 4);
        let date = new Date(this.record.last_working_date);
        let month = date.toLocaleString('default', { month: 'long' });
        let res = await this.act_fetch_fnf_days({
          le_id: this.leId,
          emp_id: this.record.employee_id,
          financial_year: year,
          month: month.substring(0,3).toLowerCase(),
          notice_recovery_days: this.formData.notice_recovery_days
        })
        //console.log(res, "dayss");
        this.formData.notice_recovery_value = Math.round(res.data.payload);
       } catch (error) {
        //console.log(error);
       }
    },
    async calculateLopDays() {
      try {
        this.formData.le_id = this.leId;
        this.formData.employee_id = this.record.employee_id;
        this.formData.processed_fnf_flag = this.record.processed_fnf_flag;
        let year = this.record.last_working_date.substring(0, 4);
        let date = new Date(this.record.last_working_date);
        let month = date.toLocaleString('default', { month: 'long' });
        let res = await this.act_fetch_fnf_days({
          le_id: this.leId,
          emp_id: this.record.employee_id,
          financial_year: year,
          month: month.substring(0,3).toLowerCase(),
          lop_days: this.formData.lop_days
        })                                                                                                                                                                                        
        this.formData.lop_amount = Math.round(res.data.payload);
      } catch (err) {
        //console.log(err);
      }
    },
    async calculateRlopDays() {
      try {
        this.formData.le_id = this.leId;
        this.formData.employee_id = this.record.employee_id;
        this.formData.processed_fnf_flag = this.record.processed_fnf_flag;
        let year = this.record.last_working_date.substring(0, 4);
        let date = new Date(this.record.last_working_date);
        let month = date.toLocaleString('default', { month: 'long' });
        let res = await this.act_fetch_fnf_days({
          le_id: this.leId,
          emp_id: this.record.employee_id,
          financial_year: year,
          month: month.substring(0,3).toLowerCase(),
          rlop_days: this.formData.rlop_days
        })                                                                                                                                                                                        
        this.formData.rlop_amount = Math.round(res.data.payload);
      } catch (err) {
        //console.log(err);
      }
    },
    saveLeaveDetail() {
      this.leavedisable = !this.leavedisable;
      if (this.leavedisable) {
        this.formData.status = this.formData.reason_for_exit;
        this.formData.id = this.record.fnfID;
        this.formData.it_declaration = [...this.itlist];
        this.formData.variable_components = [...this.variableListNew];
        this.formData.fnf_status = "pending";
        this.formData.processed_fnf_flag = this.record.processed_fnf_flag;
        this.updateEmpFnfData(this.formData);
        this.fetchEmpFnfData()
      }
    },
    saveNoticeDetail() {
      this.noticedisable = !this.noticedisable;
      if (this.noticedisable) {
        this.formData.status = this.formData.reason_for_exit;
        this.formData.id = this.record.fnfID;
        this.formData.it_declaration = [...this.itlist];
        this.formData.variable_components = [...this.variableListNew];
        this.formData.fnf_status = "pending";
        this.formData.processed_fnf_flag = this.record.processed_fnf_flag;
        this.updateEmpFnfData(this.formData);
        this.fetchEmpFnfData()
      }
    },
    saveITDetail() {
      
      //this.formData.it_declaration = this.tableData;
      
      if (this.editIT) {
        this.formData.it_declaration = [...this.itlist];
        this.formData.variable_components = [...this.variableListNew];
        this.formData.status = this.formData.reason_for_exit;
        this.formData.id = this.record.fnfID;
        this.formData.fnf_status = "pending";
        this.formData.processed_fnf_flag = this.record.processed_fnf_flag;
        this.updateEmpFnfData(this.formData);
      }
      this.editIT = !this.editIT;
    },
    saveFbpDetail() {
      this.editfbp = !this.editfbp;
    },
    saveLoanDetail() {
      this.loandisable = !this.loandisable;
    },
    showInputField(event, columnItem, index) {
      columnItem.enable = !columnItem.enable;
      //console.log(event, index, this.isChecked);
    },
    routeToMainStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation`
      });
    },
    routeToSubStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      });
    },
    //fetchSalaryComponents() {
    //  this.showSalaryComponents = true;
      // this.$emit()
      // this.$router.push({
      //   path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/variablecomponents`
      // });
    //},

    saveValues(val, record, key) {
      //console.log("Record",record);
      record[key] = val ? Number(val) : val;
      
      let itDetails = {
        name: record.particulars,
        planned: record.amount,
        actual: record.proof,
        validated: record.validated,
        id: record.id
      }
      let isPresent = this.itlist.some(x => x.name === record.particulars);
      if(isPresent) {
        let index = this.itlist.findIndex(x => x.name === record.particulars);
        this.itlist[index][key] = record[key];
      } else {
        this.itlist.push(itDetails);
      }
      //console.log(this.itlist, "6666");
    },
    preview() {
      if (this.previewScreen) {
        this.proceed();
        this.previewScreen = false;
      } else {
        this.getSalaryData();
        this.fetchEmpFnfData();
        this.previewScreen = true;
      }
    },

    getSalaryData(){
      this.getSalaryComponents =[];
      this.tableDataVariable.map(el => {
        if(el.adjustment_amount > 0){
          this.getSalaryComponents.push(el);
        }
      })
    },

    async proceed() {
      try {
        if (this.editMode) {
          this.updateEmpFnfData();
          }
        else {
          this.saveEmpFnfData();
        }
        await this.act_changeEditMode({editMode: false, record: {}});
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/fnf`
        });
      } catch (error) {
        //console.log('error', error);
      }
    },

    getCheckedItem(e, key, id) {
      this.model[key] = e;
      // if(this.model[key] == true){
      //   this.selectedComponents.push(key)
      // }
      let isPresent = this.variableList.some(x => x.name === key);
      if(isPresent) {
        if(!e){
          let index = this.variableList.findIndex(x => x.name === key);
          this.variableList.splice(index,1);
        }
      } else {
        let variableObj = {
        name: key,
        id: id
        }
        this.variableList.push(variableObj);
      }

      // this.salaryComponents.forEach(element => {
      //     let isPresent = this.variableList.some(x => x.name === element.key);
      //     if(!isPresent) {
      //       this.variableList.push({
      //         name: element.key,
      //         id: element.id
      //       });
      //     }
      // });

      // this.selectedComponents.push(variableObj);
      //variable_components json array
      this.formData.variable_components = [...this.variableList];
    },

    saveValuesVariables(val, record, key) {
      record[key] = val ? Number(val) : val;
      let variableComp = {
        component: record.component,
        type: record.type,
        adjustment_amount: record.adjustment_amount,
      }
      let isPresent = this.variableListNew.some(x => x.component === record.component);
      if(isPresent) {
        let index = this.variableListNew.findIndex(x => x.component === record.component);
        this.variableListNew[index][key] = record[key];
      } else {
        this.variableListNew.push(variableComp);
      }
    },

    async saveVariableDetail() {
      if (this.variableDisable) {
        this.variableListNew.forEach(async (ele) => {
          ele.abbreviation = 'ABC';
          this.empData[0].data.payload.salaryComponentList.forEach((ele1) =>{
            if(ele.component == ele1.name) {
              ele.abbreviation = ele1.abbreviation
            }
          });
        })
        this.formData.variable_components = [...this.variableListNew];
        this.formData.it_declaration = [...this.itlist];
        this.formData.status = this.formData.reason_for_exit;
        this.formData.id = this.record.fnfID;
        this.formData.fnf_status = "pending";
        this.formData.processed_fnf_flag = this.record.processed_fnf_flag;
        this.updateEmpFnfData(this.formData);
        this.fetchEmpFnfData();
      }
      this.variableDisable = !this.variableDisable;
    },

    // ,    processfnf(){
    //         // call api
    //         let payload = {}
    //         payload.push(this.exitDetails)
    //         payload.push(this.lop)
    //         payload.push(this.rlop)
    //         payload.push(this.leavebalance)
    //         payload.push(this.noticePayRecovery)
    //         payload.push(this.gratuityPayPeriod)
    //         payload.push(this.gratuityPayAmt)
    //         payload.push(this.salaryAdjustment)
    //         payload.push(this.ITDeclaration)
    //         payload.push(this.fbpComponentId)
    //         payload.push(this.loanAmount)
    //     }

    back() {
      this.previewScreen = false;
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/fnf`
      });
    }
  }
};
</script>

<style lang="scss" scoped>

.resetFnf{
  margin-left: 15px;
}
.verticalLine {
  padding-top: 10px;
  padding-left: 10px;
  border-left: 1px solid #f5f5f5;
}
.empdetails {
  display: flex;
  padding: 20px;
  border-bottom: 1px solid #f4f4f4;
}
.image {
  display: flex;
  flex-direction: column;
  border-right: 1px solid #f4f4f4;
  span {
    align-self: center;
  }
}

.userImage{
  width: 105px;
  height: 105px;
  padding-right: 20px;
}

.personaldetail {
  display: flex;
  flex-direction: column;
  padding: 10px 30px;
  border-right: 1px solid #f4f4f4;
  span {
    align-self: left;
  }
}
.contactdetail {
  display: flex;
  flex-direction: column;
  padding: 10px 30px;
  border-right: 1px solid #f4f4f4;
  span {
    align-self: left;
    img {
      width: 3.5%;
    }
  }
}
.amount {
  padding: 10px 30px;
  span {
    font-size: 20px;
  }
}
.custom-width {
  width: 650px;
  margin-top: 20px;
}
.lopdays {
  width: 225px;
}
.noticedays {
  width: 206px;
  margin-left: 35px;
}
.gratuitydays {
  width: 206px;
  margin-left: 20px;
}
.gratuitymargin {
  margin-left: 0px;
}
.lop {
  display: flex;
  div {
    padding-right: 20px;
  }
}
.radio {
  display: flex;
  div {
    margin-right: 30px;
  }
  .notice2 {
    margin-left: 25px;
  }
}
.gratuity {
  display: flex;
  div {
    margin-right: 30px;
    display: flex;
    // margin-top: 20px;
  }
}
.empl-fbp-table {
  .particular-table {
    width: 100%;
    border-collapse: collapse;
    th,
    td {
      padding: 10px;
    }
    thead {
      th {
        border-bottom: 2px solid #34c0be;
        background-color: #f9f9f9;
      }
    }
    .tableInput {
      width: 30%;
    }
    .total {
      border-top: 2px solid #34c0be;
      background-color: #f9f9f9;
    }
  }
}
.summary-cards {
  display: flex;
  // margin-top: 50px;
}
.rect {
  width: 270px;
  margin-right: 20px;
  margin-bottom: 30px;
  height: 132px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding: 10px;
  span {
    font-size: 14px;
    color: #5d409f;
  }
  .line {
    margin-top: 3px;
    width: 253px;
    height: 1px;
    border: solid 1px #34c0be;
    margin-bottom: 10px;
  }
}
.calculate{
  padding-top: 25px;
}
.var-rect {
  width: 270px;
  margin-right: 20px;
  margin-bottom: 30px;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding: 10px;
  span {
    font-size: 14px;
    color: #5d409f;
  }
  .line {
    margin-top: 3px;
    width: 253px;
    height: 1px;
    border: solid 1px #34c0be;
    margin-bottom: 10px;
  }
}
.custom-rect {
  width: 270px;
  margin-right: 20px;
  margin-top: -80px;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding: 10px;
  span {
    font-size: 14px;
    color: #5d409f;
  }
  .line {
    margin-top: 3px;
    width: 253px;
    height: 1px;
    border: solid 1px #34c0be;
    margin-bottom: 10px;
  }
}
.exit-details {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  span {
    font-size: 12px;
    color: #656565;
  }
}
.custom-width2 {
  width: 191px;
  height: 35px;
  margin-right:15px;
}
.custom-width3 {
  width: 91px;
  height: 35px;
  margin-right: 10px;
  margin-top: 15px;
}
.custom-div {
  margin-left: -20px;
  margin-top: 25px;
}
.variableClass {
  width: 153px;
  height: 15px;
  font-size: 12px;
  font-weight: 500;
  color: #5d409f;
  cursor: pointer;
}
.editFbpClass {
  display: flex;
  margin-right: 25px;
}
.line {
  width: 173px;
  cursor: pointer;
  border: solid 1px #5d409f;
}

</style>
